import "./cvButton.css";

const CvButton = () => {
  return (
    <a
      className="button-35"
      href="./CV-DiegoDimitroffPetcoff.pdf"
      target="_blank"
      download="CV-DiegoDimitroffPetcoff.pdf"
    >
      MY CV
    </a>
  );
};
export default CvButton;
